import React from "react";
import BuildContainer from "../Common/BuildLogs/BuildContainer";

const TestScenarioBuildLogs = ({ buildId }) => {
  return <BuildContainer buildType="testScenario" buildId={buildId} />;
};

export default TestScenarioBuildLogs;